<router-outlet> 
  <c-loading *ngIf="loading">
  </c-loading>
</router-outlet>